import { FetchNotificationPreferencesDocument, FetchNotificationPreferencesQuery } from "@/graphql/__generated__/graphql";
import { useQuery } from "@apollo/client/react";

/**
 * Custom hook for fetching notification preferences.
 * @returns {Object} - Contains the data, loading state, error state, and refetch function.
 */
export default function useFetchNotificationPreferencesQueryHook(): {
  data: FetchNotificationPreferencesQuery["fetchNotificationPreferences"] | undefined;
  loading: boolean;
  error: any;
  refetch: () => void;
  } {
  const { data, loading, error, refetch } = useQuery<FetchNotificationPreferencesQuery>(FetchNotificationPreferencesDocument, {
    fetchPolicy: "cache-and-network",
  });

  return {
    data: data?.fetchNotificationPreferences,
    loading,
    error,
    refetch,
  };
}
